export default __webpack_public_path__ + "static/media/nunito-bold.7ddd6722.ttf";